import './update-maturity-compliance-rule.scss'

import { notification } from 'antd'
import { Formik } from 'formik'
import { Form, FormItem, Input, InputNumber, SubmitButton } from 'formik-antd'
import React, { useEffect, useState } from 'react'
import { Column } from 'react-display-flex'

import { convertEntityValuesToFormValues } from '../../../../../util/convert-entity-values-to-form-values'
import { httpClient } from '../../../../../util/http-client'
import { maturityCompliancesRulesMessages } from '../messages'
import { MaturityComplianceRule } from '../models'
import { updateMaturityComplianceRuleValues } from './models'
import { maturityComplianceRuleValidationSchema } from './validators'

interface UpdateMaturityComplianceProps {
  groupId: number

  domain: string
  maturityComplianceRule: MaturityComplianceRule
  onSuccess?: () => void
}

export const UpdateMaturityCompliance = ({
  groupId,
  domain,
  maturityComplianceRule,
  onSuccess,
}: UpdateMaturityComplianceProps) => {
  const [tradeFormValues, setTradeFormValues] = useState(updateMaturityComplianceRuleValues)

  useEffect(() => {
    if (!maturityComplianceRule) return
    setTradeFormValues(convertEntityValuesToFormValues(updateMaturityComplianceRuleValues, maturityComplianceRule))
  }, [maturityComplianceRule])

  const onSubmit = async (formData) => {
    try {
      await httpClient(`/compliances/maturities/groups/${groupId}/rules/${maturityComplianceRule?.id}`, {
        method: 'PUT',
        domain,
        data: formData,
      })
      notification.success({
        message: maturityCompliancesRulesMessages.common.success,
        description: maturityCompliancesRulesMessages.update.success,
      })
      onSuccess && onSuccess()
    } catch (error) {
      notification.error({
        message: maturityCompliancesRulesMessages.common.error,
        description: maturityCompliancesRulesMessages.update.error,
      })
    }
  }

  return (
    <Formik
      initialValues={tradeFormValues}
      validationSchema={maturityComplianceRuleValidationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form name="update-maturity-compliance-rule">
        <FormItem name="ratingType" label="Rating Type" required>
          <Input name="displayTextKey" />
        </FormItem>
        <FormItem name="maturityDaysFrom" label="Maturity days from" required>
          <InputNumber name="maturityDaysFrom" />
        </FormItem>
        <FormItem name="maturityDaysTo" label="Maturity days to" required>
          <InputNumber name="maturityDaysTo" />
        </FormItem>
        <FormItem name="minLimit" label="Min Limit" required>
          <InputNumber name="minLimit" />
        </FormItem>
        <FormItem name="maxLimit" label="Max Limit" required>
          <InputNumber name="maxLimit" />
        </FormItem>
        <Column>
          <SubmitButton htmlType="submit" type="primary">
            Save Rating
          </SubmitButton>
        </Column>
      </Form>
    </Formik>
  )
}
